module.exports = __webpack_public_path__ + "img/img16.f9012474.png";